<template>
<m-pageframe
    title="After Demo Booking Surveys"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                    

                <v-list-item
                    v-on:click="onClickBookTestEvent"
                >
                    <v-list-item-title>Book a test event...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickTest"
                >
                    <v-list-item-title>Jump to dummy survey event...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

   

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.event_start_time_date="{ item }">
            {{$rc.pretty(item.event_start_time,'date')}}
        </template>

        <template v-slot:item.event_start_time_time="{ item }">
            {{$rc.pretty(item.event_start_time,'time')}}
        </template>

    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'event_start_time_date' },
                { text: 'Time', value: 'event_start_time_time' },

                { text: 'Name', value: 'invitee_full_name' },
                { text: 'Email', value: 'invitee_email' },
                { text: 'Assigned To', value: 'assigned_to' },

                { text: 'Extra Details', value: 'answer_1' },

                { text: 'Industry', value: 'industry' },
                { text: 'CRMS', value: 'crms' },
                { text: 'Reservation System', value: 'reservation_systems' },
                { text: 'Other', value: 'other_systems' },
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/sales/after-demo-booking-survey',
            
                'params' : {
                        'full_text': this.full_text,
                        'sort': 'event_start_time:desc',
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search after demo booking surveys',
            });
        },

        onClickBookTestEvent()
        {
            window.open('https://calendly.com/jim-kane/dev-test-event', '_blank');
        },

        onClickTest()
        {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow = Time.toISODateString(tomorrow);

            let url = '/app/confirm-demo-booking?assigned_to=Charlie%20Chance&event_type_uuid=4f3b8b89-3b14-461a-ad3e-cb0a094e8e0c&event_type_name=Dev%20Test%20Event&event_start_time='+tomorrow+'T07%3A30%3A00-10%3A00&event_end_time='+tomorrow+'T07%3A45%3A00-10%3A00&invitee_uuid=79b8609c-22cc-4877-b966-61baa5d15ab3&invitee_full_name=Tom%20Hall&invitee_email=th%40gmail.com&answer_1=Foo';

            window.open(url,'_blank');            
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>